import React, { Component } from 'react';
import DatePicker from 'react-date-picker';
import Icon from "../../icons/icons";
import "./datepicker.css";

class Datepicker extends Component {
  state = {
    date: this.props.value,
  }

  onChange = (el) => {
    this.setState({
      date: el
    })
    function convert(str) {
      var date = new Date(str),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2),
        hours = ("0" + date.getHours()).slice(-2),
        minutes = ("0" + date.getMinutes()).slice(-2),
        seconds = ("0" + date.getSeconds()).slice(-2);
      return (date.getFullYear() + "-" + mnth + "-" + day + "T" + hours + ":" + minutes + ":" + seconds);
    }
    this.props.handleDate(convert(el));
  }

  onClose = () => {
    var dateinput = document.querySelector("[name=" + this.props.name + "]")
    if (dateinput.value.length) {
      var datepicker = dateinput.parentNode.parentNode;
      datepicker.classList.remove("invalid-input");
      var parentN = datepicker.parentNode;
      var errorMessage = parentN.querySelector(".error-message")
      if (errorMessage) {
        errorMessage.classList.remove("error-message")
        errorMessage.innerText = '';
      }
    }
  }

  render() {
    return (
      <div>
        <div className="datepicker_label">{this.props.label}</div>
        <div className="datepicker_container">
          <DatePicker
            value={this.state.date}
            minDate={this.props.minDate}
            maxDate={this.props.maxDate}
            name={this.props.name}
            required={this.props.required}
            disabled={this.props.disabled}
            format="dd.MM.yyyy"
            dayPlaceholder="дд"
            monthPlaceholder="мм"
            yearPlaceholder="гггг"
            clearIcon={null}
            onChange={this.onChange}
            onCalendarClose={this.onClose}
            calendarIcon={<Icon name="icon_date" viewbox="0 0 24 24" />}
          />
        </div>
        <div className="datepicker_underinput">{this.props.underinput}</div>
      </div>
    );
  }
}

export default Datepicker;